//
//
//
//
//
//
//
//

import LineageTableau from '@/modules/tasks/tableau/components/LineageTableau';
export default {
  name: 'DashboardTabLineage',
  components: {
    LineageTableau: LineageTableau
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      data_lineage: {}
    };
  },
  created: function created() {
    var datasources = this.item.datasource_path.map(function (element) {
      element.type = 'DATASOURCE';
      return element;
    });
    this.data_lineage = {
      tables: datasources,
      datasource: {
        type: 'DASHBOARD',
        object_name: this.item.object_name,
        focus: true
      },
      views: this.item.views
    };
  }
};